import { Modal, ModalBody, ModalHeader, Header, ModalFooter, Button, FontAwesomeIcon, Flex } from "@nef/core"

import { DeleteModalProps } from "../../types/common"

const DeleteConfirmationModal = ({ isOpen, info, onConfirm, toggle, isLoading, headerText, deleteButtonText }: DeleteModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} closeOnOutsideClick={false} size="md">
      <ModalHeader
        data-testid="modalHeader"
        toggle={toggle}
        title={
          <>
            <Flex>
              <FontAwesomeIcon iconSetClassName="fas" iconClassName="fa-exclamation-triangle" style={{ color: "crimson", marginRight: "1rem" }} />
              {headerText || "Confirm Deletion"}
            </Flex>
          </>
        }
      />
      <ModalBody>
        <Header size={4}>{info}</Header>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm} isLoading={isLoading} autoFocus>
          {deleteButtonText || "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeleteConfirmationModal
